/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCloneFragmentDetailMutationRequest, WebAppCloneFragmentDetailMutationResponse, WebAppCloneFragmentDetailPathParams } from "../models/WebAppCloneFragmentDetail";

export function getWebAppCloneFragmentDetailUrl(id: WebAppCloneFragmentDetailPathParams["id"]) {
  const res = { method: 'POST', url: `/web-app/v1/fragments/${id}/clone` as const }
  return res
}

/**
 * @summary Clone a fragment
 * {@link /web-app/v1/fragments/:id/clone}
 */
export async function webAppCloneFragmentDetail(id: WebAppCloneFragmentDetailPathParams["id"], data: WebAppCloneFragmentDetailMutationRequest, config: Partial<RequestConfig<WebAppCloneFragmentDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, WebAppCloneFragmentDetailMutationRequest>({ method : "POST", url : getWebAppCloneFragmentDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}